import { useState } from "react";
import { API_URL } from '../config/api'

const useHandleSubmit = () => {
  const [price, setPrice] = useState("0");
  const [description, setDescription] = useState("");
  const [priceError, setPriceError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (price === "") {
      setPriceError("入力されていません");
      return;
    }
    if (price === "0") {
      setPriceError("入力されていません");
      return;
    }
    if (!price.match(/^[0-9]*$/)) {
      console.log("hello");
      setPriceError("文字が含まれています");
      return;
    }
    if (description.length === 0) {
      setDescriptionError("何も入力されていません");
      return;
    }

    const token = localStorage.getItem("token");
    if (token === "") {
      console.log("tokenがあリませんでした");
      return;
    }

    try {
      // リクエスト
      const response = await fetch(`${API_URL}/api/items`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          token: token,
          imgUrl:
            "https://static.mercdn.net/c!/w=240/thumb/photos/m32244617047_1.jpg?1607253250",
          price: price,
          description: description,
        }),
      }); // POST method
      const resJson = await response.json();
      console.log("resJson", resJson);
    } catch (err) {
      console.log(err);
    }

    // /items GET -> 全ての商品を取得
    // /items POST -> 商品を追加
    // /items/{id} GET -> idの商品を取得する
    // /items/{id} DELETE -> idの商品を消す
  };

  return [
    price,
    description,
    priceError,
    descriptionError,
    handleSubmit,
    setPrice,
    setDescription,
  ];
};

export { useHandleSubmit };
